import { UiSchema, WidgetProps } from '@rjsf/utils';
import { CustomObjectFieldTemplate, UIGridElement } from '../shared/custom-object-field-template';
import { DynamicFormAutocomplete } from '../shared/dynamic-form-autocomplete';
import { StaticTextWidget } from '../shared/static-text-widget';

const uiGrid: UIGridElement[] = [{ fields: { hubName: 6, projectId: 6 } }];

export const relationshipFormUISchema: UiSchema = {
  'ui:submitButtonOptions': {
    norender: true
  },
  'ui:field': 'custom',
  'ui:grid': uiGrid,
  'ui:ObjectFieldTemplate': CustomObjectFieldTemplate,
  hubName: {
    'ui:widget': (props: WidgetProps) => <StaticTextWidget {...props} />
  },
  projectId: {
    'ui:widget': (props: WidgetProps) => <DynamicFormAutocomplete {...props} />
  }
};
